import { Dialog } from '@hb/coffee';


export const dingTalkRejectDialog = (): Promise<unknown> => Dialog.alert({
  title: '该平台已下线',
  message: '请前往哈啰APP使用服务',
  confirmButtonText: '知道了',
  closeable: false,
}).then(() => {
  // 点击知道了，会关闭对话框
});
